/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Toast_Added_FilesInputs */

const en_toast_added_files = /** @type {(inputs: Toast_Added_FilesInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Added ${i?.count} file to your library`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Added ${i?.count} files to your library`);
	return /** @type {LocalizedString} */ ("toast_added_files");
};

const es_toast_added_files = /** @type {(inputs: Toast_Added_FilesInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Se agregaron ${i?.count} archivo a tu biblioteca`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Se agregaron ${i?.count} archivos a tu biblioteca`);
	return /** @type {LocalizedString} */ ("toast_added_files");
};

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "Added {count} file to your library" |
* | "other" | "Added {count} files to your library" |
*
* @param {Toast_Added_FilesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const toast_added_files = /** @type {((inputs: Toast_Added_FilesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Added_FilesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_toast_added_files(inputs)
	return en_toast_added_files(inputs)
});